import React from 'react';
import { FaPhoneAlt, FaWhatsapp, FaSun } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import SUMMER_CAMPAIGN, { isCampaignActive } from '../../Data/campaignConfig';
import './SummerCampaignBar.css';

const SummerCampaignBar = () => {
  if (!isCampaignActive(SUMMER_CAMPAIGN)) return null;

  const whatsappHref = SITE.whatsappMessage(SUMMER_CAMPAIGN.whatsappText);

  return (
    <div className="summer-campaign-bar" role="region" aria-label="Yaz kampanyası duyurusu">
      <div className="summer-campaign-bar-inner">
        <div className="scb-badge">
          <FaSun className="scb-sun" aria-hidden />
          <span>YAZ KAMPANYASI</span>
        </div>

        <div className="scb-marquee-wrap" aria-hidden="true">
          <div className="scb-marquee">
            <span className="scb-marquee-text">
              {SUMMER_CAMPAIGN.barMarqueeText}
              <span className="scb-price-pulse"> · {SUMMER_CAMPAIGN.priceDisplay}</span>
            </span>
            <span className="scb-marquee-text">
              {SUMMER_CAMPAIGN.barMarqueeText}
              <span className="scb-price-pulse"> · {SUMMER_CAMPAIGN.priceDisplay}</span>
            </span>
          </div>
        </div>

        <p className="scb-static-text">
          {SUMMER_CAMPAIGN.barMarqueeText}
          <strong className="scb-price-pulse"> · {SUMMER_CAMPAIGN.priceDisplay}</strong>
        </p>

        <div className="scb-actions">
          <a href={SITE.phoneHref} className="scb-btn scb-btn-call">
            <FaPhoneAlt aria-hidden /> Ara
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="scb-btn scb-btn-wa"
          >
            <FaWhatsapp aria-hidden /> WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default SummerCampaignBar;
